import React from 'react'
import { colors } from './fieldTheme'
import { searchObjects, isGap, objectReferenceLines, isMissingAtReference, missingLabel, plural } from './fieldReference'
import { ThemeIllustration, NoResultIcon } from './FieldIcons'
import { Notice, PrimaryButton } from './FieldUI'
import FieldItemRow from './FieldItemRow'

// Recherche d'un objet dans tous les thèmes (canvas W7e, décision 24) :
// on corrige le comptage directement dans les résultats, sans entrer dans le thème.

export default function FieldSearchAll({ query, themes, reference, counts, onCount, onDone })
{
	const groups = searchObjects(themes, query)
	const found = groups.reduce((total, group) => total + group.objects.length, 0)
	const absentLabel = missingLabel(reference)

	return (
		<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
			{found > 0 ? (
				<React.Fragment>
					<p role="status" style={{ padding: '16px 20px 0', fontSize: 15, fontWeight: 700, color: colors.textSecondary }}>
						{plural(found, 'résultat') + ' dans ' + plural(groups.length, 'thème')}
					</p>
					{groups.map(group => (
						<section key={group.theme.id}>
							<h2 style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 15, fontWeight: 700, color: colors.textSecondary, letterSpacing: '.04em', textTransform: 'uppercase', padding: '24px 20px 12px' }}>
								<span aria-hidden="true" style={{ width: 32, height: 32, borderRadius: 999, background: '#E8EBF5', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
									<ThemeIllustration name={group.theme.name} size={24} />
								</span>
								{group.theme.name}
							</h2>
							<div style={{ margin: '0 20px', background: colors.surface, borderRadius: 18, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
								{group.objects.map((object, i) => {
									const ref = reference.counts[object.id]
									return (
										<FieldItemRow
											key={object.id}
											object={object}
											value={counts[object.id] !== undefined ? counts[object.id] : ref}
											reference={ref}
											referenceLines={objectReferenceLines(object, reference)}
											missingLabel={isMissingAtReference(object, reference) ? absentLabel : null}
											gap={isGap(object, counts, reference)}
											first={i === 0}
											minHeight={80}
											onChange={(next) => onCount(object.id, next)}
										/>
									)
								})}
							</div>
						</section>
					))}
					<p style={{ padding: '12px 20px 0', fontSize: 15, fontWeight: 500, color: colors.textSecondary }}>Chaque correction compte tout de suite dans son thème.</p>
				</React.Fragment>
			) : (
				<Notice icon={<NoResultIcon />} title={'Aucun objet pour « ' + query.trim() + ' »'} hint="Vérifiez l'orthographe : la recherche porte sur tous les thèmes." />
			)}
			<div style={{ position: 'sticky', bottom: 0, marginTop: 'auto', padding: '24px 20px', paddingBottom: 'max(28px, env(safe-area-inset-bottom))', background: colors.background, display: 'flex' }}>
				<PrimaryButton onClick={onDone}>Retour aux thèmes</PrimaryButton>
			</div>
		</div>
	)
}
